import React, { useState, useEffect } from "react";
import {
  Box, Paper, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Grid, Alert, Snackbar,
  IconButton, Tooltip, Chip, FormControl, InputLabel, Select, MenuItem,
  InputAdornment, Divider
} from "@mui/material";
import {
  Add, Edit, Delete, Search, Refresh, Business, Phone, Email,
  Visibility, AccountBalance
} from "@mui/icons-material";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const BANCOS_ECUADOR = [
  "BANCO PICHINCHA", "BANCO GUAYAQUIL", "PRODUBANCO", "BANCO DEL PACÍFICO",
  "BANCO INTERNACIONAL", "BANCO BOLIVARIANO", "COOPERATIVA JEP",
  "BANCO DEL AUSTRO", "BANCO SOLIDARIO", "BANCO GENERAL RUMIÑAHUI",
  "COOPERATIVA POLICÍA NACIONAL", "COOPERATIVA 29 DE OCTUBRE",
  "MUTUALISTA PICHINCHA", "BANCOOMEVA", "OTRO"
];

const REGIMENES = ["GENERAL", "GRAN CONTRIBUYENTE", "CONTRIBUYENTE ESPECIAL", "RIMPE EMPRENDEDOR", "RIMPE POPULAR"];
const TIPOS_PERSONA = ["NATURAL", "JURIDICA"];

const PROVINCIAS_ECUADOR = [
  "AZUAY","BOLÍVAR","CAÑAR","CARCHI","CHIMBORAZO","COTOPAXI",
  "EL ORO","ESMERALDAS","GALÁPAGOS","GUAYAS","IMBABURA","LOJA",
  "LOS RÍOS","MANABÍ","MORONA SANTIAGO","NAPO","ORELLANA",
  "PASTAZA","PICHINCHA","SANTA ELENA","SANTO DOMINGO DE LOS TSÁCHILAS",
  "SUCUMBÍOS","TUNGURAHUA","ZAMORA CHINCHIPE"
];

const CIUDADES_POR_PROVINCIA = {
  "AZUAY": ["CUENCA", "GUALACEO", "PAUTE", "SÍGSIG", "SANTA ISABEL"],
  "BOLÍVAR": ["GUARANDA", "SAN MIGUEL", "CHILLANES", "CHIMBO"],
  "CAÑAR": ["AZOGUES", "CAÑAR", "LA TRONCAL", "BIBLIÁN"],
  "CARCHI": ["TULCÁN", "SAN GABRIEL", "EL ÁNGEL", "MIRA"],
  "CHIMBORAZO": ["RIOBAMBA", "ALAUSÍ", "COLTA", "GUANO", "CHAMBO"],
  "COTOPAXI": ["LATACUNGA", "SALCEDO", "SAQUISILÍ", "PUJILÍ", "LA MANÁ"],
  "EL ORO": ["MACHALA", "PASAJE", "SANTA ROSA", "HUAQUILLAS", "PIÑAS"],
  "ESMERALDAS": ["ESMERALDAS", "ATACAMES", "QUININDÉ", "SAN LORENZO"],
  "GALÁPAGOS": ["PUERTO BAQUERIZO MORENO", "PUERTO AYORA"],
  "GUAYAS": ["GUAYAQUIL", "DURÁN", "SAMBORONDÓN", "DAULE", "MILAGRO"],
  "IMBABURA": ["IBARRA", "OTAVALO", "COTACACHI", "ANTONIO ANTE"],
  "LOJA": ["LOJA", "CATAMAYO", "MACARÁ", "SARAGURO"],
  "LOS RÍOS": ["BABAHOYO", "QUEVEDO", "VENTANAS", "VINCES"],
  "MANABÍ": ["PORTOVIEJO", "MANTA", "CHONE", "JIPIJAPA", "EL CARMEN"],
  "MORONA SANTIAGO": ["MACAS", "GUALAQUIZA", "SUCÚA"],
  "NAPO": ["TENA", "ARCHIDONA", "EL CHACO"],
  "ORELLANA": ["FRANCISCO DE ORELLANA (COCA)", "JOYA DE LOS SACHAS"],
  "PASTAZA": ["PUYO", "MERA", "SANTA CLARA"],
  "PICHINCHA": ["QUITO", "CAYAMBE", "MEJÍA", "RUMIÑAHUI", "PEDRO MONCAYO", "PUERTO QUITO"],
  "SANTA ELENA": ["SANTA ELENA", "LA LIBERTAD", "SALINAS"],
  "SANTO DOMINGO DE LOS TSÁCHILAS": ["SANTO DOMINGO", "LA CONCORDIA"],
  "SUCUMBÍOS": ["NUEVA LOJA (LAGO AGRIO)", "SHUSHUFINDI"],
  "TUNGURAHUA": ["AMBATO", "BAÑOS", "PELILEO", "PÍLLARO"],
  "ZAMORA CHINCHIPE": ["ZAMORA", "YANTZAZA", "NANGARITZA"]
};

const emptyForm = {
  ruc_cedula: "", razon_social: "", nombre_comercial: "",
  tipo_persona: "NATURAL", regimen: "GENERAL", obligado_contabilidad: "NO",
  pais: "ECUADOR", provincia: "", ciudad: "",
  direccion: "", telefono: "", celular: "", emails: [],
  nombre_contacto: "", telefono_contacto: "", email_contacto: "", notas: "",
  plazo_credito_dias: 0, limite_credito: 0,
  banco_nombre: "", banco_cuenta: "", banco_tipo_cuenta: "", banco_cedula_titular: "", banco_nombre_titular: "",
  activo: true,
};

export default function Proveedores() {
  const [proveedores, setProveedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editando, setEditando] = useState(false);
  const [proveedorSel, setProveedorSel] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [busqueda, setBusqueda] = useState("");
  const [formData, setFormData] = useState({ ...emptyForm });
  const [emailInput, setEmailInput] = useState("");
  const [verProveedor, setVerProveedor] = useState(null);
  const [pagina, setPagina] = useState(0);
  const POR_PAGINA = 20;

  const getAuthHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

  useEffect(() => { cargar(); }, [busqueda]);

  const cargar = async () => {
    setLoading(true);
    try {
      const params = busqueda ? `?busqueda=${busqueda}` : "";
      const res = await axios.get(`${API_URL}/api/proveedores${params}`, { headers: getAuthHeaders() });
      setProveedores(Array.isArray(res.data) ? res.data : []);
    } catch { setProveedores([]); }
    setLoading(false);
  };

  const handleInput = (campo, valor) => {
    const upper = ["razon_social", "nombre_comercial", "nombre_contacto", "direccion", "banco_nombre_titular"];
    const v = upper.includes(campo) && typeof valor === "string" ? valor.toUpperCase() : valor;
    setFormData(prev => ({ ...prev, [campo]: v }));
  };

  const agregarEmail = () => {
    if (!emailInput || !emailInput.includes("@")) return;
    setFormData(prev => ({ ...prev, emails: [...(prev.emails || []), emailInput] }));
    setEmailInput("");
  };
  const eliminarEmail = (idx) => setFormData(prev => ({ ...prev, emails: prev.emails.filter((_, i) => i !== idx) }));

  const abrirDialogo = (p = null) => {
    if (p) {
      setEditando(true); setProveedorSel(p);
      setFormData({ ...emptyForm, ...p, ruc_cedula: p.ruc_cedula || p.numero_identificacion || "", emails: p.emails || [] });
    } else { setEditando(false); setProveedorSel(null); setFormData({ ...emptyForm }); }
    setEmailInput(""); setDialogOpen(true);
  };
  const cerrarDialogo = () => { setDialogOpen(false); setEditando(false); setProveedorSel(null); };

  const guardar = async () => {
    if (!formData.ruc_cedula || !formData.razon_social) return showSnackbar("RUC y Razón Social requeridos", "error");
    try {
      const url = editando ? `${API_URL}/api/proveedores/${proveedorSel.id}` : `${API_URL}/api/proveedores`;
      const method = editando ? "put" : "post";
      const data = { ...formData, numero_identificacion: formData.ruc_cedula, tipo_identificacion: formData.ruc_cedula.length === 13 ? "04" : "05" };
      await axios[method](url, data, { headers: getAuthHeaders() });
      showSnackbar(editando ? "Proveedor actualizado" : "Proveedor creado", "success");
      cerrarDialogo(); cargar();
    } catch (e) { showSnackbar(e.response?.data?.error || "Error al guardar", "error"); }
  };

  const eliminar = async (p) => {
    if (!window.confirm(`¿Desactivar proveedor ${p.razon_social}?`)) return;
    try { await axios.delete(`${API_URL}/api/proveedores/${p.id}`, { headers: getAuthHeaders() }); showSnackbar("Desactivado", "success"); cargar(); }
    catch (e) { showSnackbar(e.response?.data?.error || "Error", "error"); }
  };

  const showSnackbar = (message, severity) => setSnackbar({ open: true, message, severity });

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Business />
            <Typography variant="h5" fontWeight={700}>Proveedores</Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button variant="outlined" startIcon={<Refresh />} onClick={cargar}>Actualizar</Button>
            <Button variant="contained" startIcon={<Add />} onClick={() => abrirDialogo()}>Nuevo Proveedor</Button>
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <TextField fullWidth size="small" placeholder="Buscar por RUC, razón social..." value={busqueda}
            onChange={(e) => { setBusqueda(e.target.value); setPagina(0); }}
            InputProps={{ startAdornment: <Search sx={{ mr: 1, color: "text.secondary" }} /> }} />
        </Box>

        {loading ? <Typography>Cargando...</Typography> : proveedores.length === 0 ? (
          <Alert severity="info">No hay proveedores registrados.</Alert>
        ) : (
          <>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                    <TableCell><strong>RUC / CI</strong></TableCell>
                    <TableCell><strong>Razón Social</strong></TableCell>
                    <TableCell><strong>Contacto</strong></TableCell>
                    <TableCell><strong>Referencia</strong></TableCell>
                    <TableCell align="center"><strong>Acciones</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {proveedores.slice(pagina * POR_PAGINA, (pagina + 1) * POR_PAGINA).map((p) => (
                    <TableRow key={p.id} hover>
                      <TableCell><Typography variant="body2" fontFamily="monospace">{p.ruc_cedula || p.numero_identificacion || "—"}</Typography></TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={600}>{p.razon_social}</Typography>
                        {p.nombre_comercial && <Typography variant="caption" color="text.secondary">{p.nombre_comercial}</Typography>}
                      </TableCell>
                      <TableCell>
                        {(p.celular || p.telefono) && <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}><Phone sx={{ fontSize: 14 }} /><Typography variant="caption">{p.celular || p.telefono}</Typography></Box>}
                        {(p.emails?.length > 0) && <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}><Email sx={{ fontSize: 14 }} /><Typography variant="caption">{p.emails[0]}</Typography></Box>}
                      </TableCell>
                      <TableCell>
                        {p.nombre_contacto && <Typography variant="caption" display="block" fontWeight={600}>{p.nombre_contacto}</Typography>}
                        {p.telefono_contacto && <Typography variant="caption" display="block">{p.telefono_contacto}</Typography>}
                        {p.email_contacto && <Typography variant="caption" display="block">{p.email_contacto}</Typography>}
                        {!p.nombre_contacto && !p.telefono_contacto && !p.email_contacto && <Typography variant="caption" color="text.secondary">—</Typography>}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Ver detalle"><IconButton size="small" onClick={() => setVerProveedor(p)}><Visibility /></IconButton></Tooltip>
                        <Tooltip title="Estado de Cuenta"><IconButton size="small" color="info" onClick={() => window.location.href = `/cuentas-pagar/estado-cuenta/${p.id}`}><AccountBalance /></IconButton></Tooltip>
                        <Tooltip title="Editar"><IconButton size="small" onClick={() => abrirDialogo(p)}><Edit /></IconButton></Tooltip>
                        {p.activo !== false && <Tooltip title="Desactivar"><IconButton size="small" color="error" onClick={() => eliminar(p)}><Delete /></IconButton></Tooltip>}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2, px: 1 }}>
              <Typography variant="body2" color="text.secondary">
                {Math.min(pagina * POR_PAGINA + 1, proveedores.length)}–{Math.min((pagina + 1) * POR_PAGINA, proveedores.length)} de {proveedores.length}
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button variant="outlined" size="small" disabled={pagina === 0} onClick={() => setPagina(pagina - 1)}>← Anterior</Button>
                <Button variant="outlined" size="small" disabled={(pagina + 1) * POR_PAGINA >= proveedores.length} onClick={() => setPagina(pagina + 1)}>Siguiente →</Button>
              </Box>
            </Box>
          </>
        )}
      </Paper>

      {/* Dialog Crear/Editar */}
      <Dialog open={dialogOpen} onClose={cerrarDialogo} fullWidth PaperProps={{ sx: { borderRadius: 3, maxWidth: 900, width: "95vw" } }}>
        <DialogTitle sx={{ pb: 1, fontWeight: 700, fontSize: 20 }}>{editando ? "✏️ Editar Proveedor" : "➕ Nuevo Proveedor"}</DialogTitle>
        <Divider />
        <DialogContent sx={{ pt: 3 }}>
          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>Identificación</Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, md: 3 }}><TextField fullWidth required label="RUC / Cédula" value={formData.ruc_cedula} onChange={(e) => handleInput("ruc_cedula", e.target.value.replace(/\D/g, ""))} inputProps={{ maxLength: 13, style: { fontSize: 16 } }} helperText="10 o 13 dígitos" disabled={editando} /></Grid>
            <Grid size={{ xs: 12, md: 5 }}><TextField fullWidth required label="Razón Social" value={formData.razon_social} onChange={(e) => handleInput("razon_social", e.target.value)} inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 4 }}><TextField fullWidth label="Nombre Comercial" value={formData.nombre_comercial} onChange={(e) => handleInput("nombre_comercial", e.target.value)} inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} /></Grid>
          </Grid>

          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>Contacto</Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, md: 4 }}><TextField fullWidth label="Email" value={emailInput} onChange={(e) => setEmailInput(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); agregarEmail(); } }} placeholder="correo@ejemplo.com" inputProps={{ style: { fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 2 }}><Button variant="outlined" onClick={agregarEmail} fullWidth sx={{ height: 56 }}>+ Email</Button></Grid>
            <Grid size={{ xs: 12, md: 3 }}><TextField fullWidth label="Teléfono" value={formData.telefono} onChange={(e) => handleInput("telefono", e.target.value)} inputProps={{ style: { fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 3 }}><TextField fullWidth label="Celular" value={formData.celular} onChange={(e) => handleInput("celular", e.target.value)} inputProps={{ style: { fontSize: 16 } }} /></Grid>
            {formData.emails?.length > 0 && <Grid size={12}><Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>{formData.emails.map((em, i) => <Chip key={i} label={em} onDelete={() => eliminarEmail(i)} size="small" color="primary" variant="outlined" />)}</Box></Grid>}
            <Grid size={{ xs: 12, md: 6 }}><TextField fullWidth label="Dirección" value={formData.direccion} onChange={(e) => handleInput("direccion", e.target.value)} inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 3 }}><TextField fullWidth label="Nombre de Contacto" value={formData.nombre_contacto} onChange={(e) => handleInput("nombre_contacto", e.target.value)} inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 3 }}><TextField fullWidth label="Teléfono Contacto" value={formData.telefono_contacto || ""} onChange={(e) => handleInput("telefono_contacto", e.target.value)} inputProps={{ style: { fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 6 }}><TextField fullWidth label="Email Contacto" value={formData.email_contacto || ""} onChange={(e) => handleInput("email_contacto", e.target.value)} inputProps={{ style: { fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 6 }}><TextField fullWidth label="Notas" value={formData.notas || ""} onChange={(e) => handleInput("notas", e.target.value)} inputProps={{ style: { fontSize: 16 } }} /></Grid>
          </Grid>

          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>Ubicación</Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>País</InputLabel><Select value={formData.pais || "ECUADOR"} label="País" onChange={(e) => { handleInput("pais", e.target.value); if (e.target.value !== "ECUADOR") { handleInput("provincia", ""); handleInput("ciudad", ""); } }}><MenuItem value="ECUADOR">ECUADOR</MenuItem><MenuItem value="COLOMBIA">COLOMBIA</MenuItem><MenuItem value="PERÚ">PERÚ</MenuItem><MenuItem value="ESTADOS UNIDOS">ESTADOS UNIDOS</MenuItem><MenuItem value="ESPAÑA">ESPAÑA</MenuItem><MenuItem value="OTRO">OTRO</MenuItem></Select></FormControl></Grid>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>Provincia</InputLabel><Select value={formData.provincia || ""} label="Provincia" onChange={(e) => { handleInput("provincia", e.target.value); handleInput("ciudad", ""); }}><MenuItem value="">— Seleccionar —</MenuItem>{PROVINCIAS_ECUADOR.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}</Select></FormControl></Grid>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>Ciudad</InputLabel><Select value={formData.ciudad || ""} label="Ciudad" onChange={(e) => handleInput("ciudad", e.target.value)}><MenuItem value="">— Seleccionar —</MenuItem>{(CIUDADES_POR_PROVINCIA[formData.provincia] || []).map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}</Select></FormControl></Grid>
          </Grid>

          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>Configuración Fiscal</Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>Régimen</InputLabel><Select value={formData.regimen} label="Régimen" onChange={(e) => handleInput("regimen", e.target.value)}>{REGIMENES.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}</Select></FormControl></Grid>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>Tipo de Persona</InputLabel><Select value={formData.tipo_persona} label="Tipo de Persona" onChange={(e) => handleInput("tipo_persona", e.target.value)}>{TIPOS_PERSONA.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}</Select></FormControl></Grid>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>Obligado a Contabilidad</InputLabel><Select value={formData.obligado_contabilidad} label="Obligado a Contabilidad" onChange={(e) => handleInput("obligado_contabilidad", e.target.value)}><MenuItem value="SI">Sí</MenuItem><MenuItem value="NO">No</MenuItem></Select></FormControl></Grid>
          </Grid>

          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>Condiciones de Crédito</Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>Plazo de Crédito</InputLabel><Select value={formData.plazo_credito_dias} label="Plazo de Crédito" onChange={(e) => { const v = parseInt(e.target.value) || 0; handleInput("plazo_credito_dias", v); if (v === 0) handleInput("limite_credito", 0); }}><MenuItem value={0}>Sin crédito</MenuItem><MenuItem value={30}>30 días</MenuItem><MenuItem value={60}>60 días</MenuItem><MenuItem value={90}>90 días</MenuItem></Select></FormControl></Grid>
            <Grid size={{ xs: 12, md: 4 }}><TextField fullWidth label="Cupo Máximo" type="number" value={formData.limite_credito} onChange={(e) => handleInput("limite_credito", parseFloat(e.target.value) || 0)} InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }} inputProps={{ min: 0, step: 0.01, style: { fontSize: 16 } }} disabled={formData.plazo_credito_dias === 0} /></Grid>
          </Grid>

          <Typography variant="subtitle1" fontWeight={700} color="primary" sx={{ mb: 2 }}>Datos Bancarios</Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>Banco</InputLabel><Select value={formData.banco_nombre || ""} label="Banco" onChange={(e) => handleInput("banco_nombre", e.target.value)}><MenuItem value="">— Sin banco —</MenuItem>{BANCOS_ECUADOR.map(b => <MenuItem key={b} value={b}>{b}</MenuItem>)}</Select></FormControl></Grid>
            <Grid size={{ xs: 12, md: 4 }}><TextField fullWidth label="Número de Cuenta" value={formData.banco_cuenta || ""} onChange={(e) => handleInput("banco_cuenta", e.target.value)} inputProps={{ style: { fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 4 }}><FormControl fullWidth><InputLabel>Tipo Cuenta</InputLabel><Select value={formData.banco_tipo_cuenta || ""} label="Tipo Cuenta" onChange={(e) => handleInput("banco_tipo_cuenta", e.target.value)}><MenuItem value="">—</MenuItem><MenuItem value="AHORROS">Ahorros</MenuItem><MenuItem value="CORRIENTE">Corriente</MenuItem></Select></FormControl></Grid>
            <Grid size={{ xs: 12, md: 4 }}><TextField fullWidth label="Cédula/RUC Titular" value={formData.banco_cedula_titular || ""} onChange={(e) => handleInput("banco_cedula_titular", e.target.value)} inputProps={{ style: { fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 4 }}><TextField fullWidth label="Nombre Titular" value={formData.banco_nombre_titular || ""} onChange={(e) => handleInput("banco_nombre_titular", e.target.value)} inputProps={{ style: { textTransform: "uppercase", fontSize: 16 } }} /></Grid>
            <Grid size={{ xs: 12, md: 4 }}><TextField fullWidth label="Observaciones" value={formData.banco_observaciones || ""} onChange={(e) => handleInput("banco_observaciones", e.target.value)} inputProps={{ style: { fontSize: 16 } }} placeholder="Detalles adicionales de la cuenta" /></Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={cerrarDialogo} color="inherit">Cancelar</Button>
          <Button onClick={guardar} variant="contained" size="large">{editando ? "Actualizar" : "Crear"} Proveedor</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Ver Detalle */}
      <Dialog open={!!verProveedor} onClose={() => setVerProveedor(null)} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        {verProveedor && (<>
          <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>👁️ {verProveedor.razon_social}</DialogTitle>
          <Divider />
          <DialogContent sx={{ pt: 2 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle2" color="primary" gutterBottom>Identificación</Typography>
                <Box sx={{ pl: 1, mb: 2 }}>
                  <Typography variant="body2"><strong>RUC/CI:</strong> {verProveedor.ruc_cedula || verProveedor.numero_identificacion || "—"}</Typography>
                  <Typography variant="body2"><strong>Razón Social:</strong> {verProveedor.razon_social || "—"}</Typography>
                  <Typography variant="body2"><strong>Nombre Comercial:</strong> {verProveedor.nombre_comercial || "—"}</Typography>
                </Box>
                <Typography variant="subtitle2" color="primary" gutterBottom>Contacto</Typography>
                <Box sx={{ pl: 1, mb: 2 }}>
                  <Typography variant="body2"><strong>Emails:</strong> {(verProveedor.emails || []).join(", ") || "—"}</Typography>
                  <Typography variant="body2"><strong>Teléfono:</strong> {verProveedor.telefono || "—"}</Typography>
                  <Typography variant="body2"><strong>Celular:</strong> {verProveedor.celular || "—"}</Typography>
                  <Typography variant="body2"><strong>Dirección:</strong> {verProveedor.direccion || verProveedor.direccion_principal || "—"}</Typography>
                </Box>
                <Typography variant="subtitle2" color="primary" gutterBottom>Referencia</Typography>
                <Box sx={{ pl: 1 }}>
                  <Typography variant="body2"><strong>Contacto:</strong> {verProveedor.nombre_contacto || "—"}</Typography>
                  <Typography variant="body2"><strong>Tel. Contacto:</strong> {verProveedor.telefono_contacto || "—"}</Typography>
                  <Typography variant="body2"><strong>Email Contacto:</strong> {verProveedor.email_contacto || "—"}</Typography>
                  <Typography variant="body2"><strong>Notas:</strong> {verProveedor.notas || "—"}</Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle2" color="primary" gutterBottom>Fiscal</Typography>
                <Box sx={{ pl: 1, mb: 2 }}>
                  <Typography variant="body2"><strong>Régimen:</strong> {verProveedor.regimen || verProveedor.tipo_contribuyente || "GENERAL"}</Typography>
                  <Typography variant="body2"><strong>Tipo Persona:</strong> {verProveedor.tipo_persona || "NATURAL"}</Typography>
                  <Typography variant="body2"><strong>Obligado Contabilidad:</strong> {verProveedor.obligado_contabilidad || "NO"}</Typography>
                </Box>
                <Typography variant="subtitle2" color="primary" gutterBottom>Crédito</Typography>
                <Box sx={{ pl: 1, mb: 2 }}>
                  <Typography variant="body2"><strong>Plazo:</strong> {verProveedor.plazo_credito_dias ? `${verProveedor.plazo_credito_dias} días` : "Sin crédito"}</Typography>
                  <Typography variant="body2"><strong>Cupo:</strong> ${parseFloat(verProveedor.limite_credito || 0).toFixed(2)}</Typography>
                </Box>
                <Typography variant="subtitle2" color="primary" gutterBottom>Banco</Typography>
                <Box sx={{ pl: 1 }}>
                  <Typography variant="body2"><strong>Banco:</strong> {verProveedor.banco_nombre || "—"}</Typography>
                  <Typography variant="body2"><strong>Cuenta:</strong> {verProveedor.banco_cuenta || "—"}</Typography>
                  <Typography variant="body2"><strong>Tipo:</strong> {verProveedor.banco_tipo_cuenta || "—"}</Typography>
                  <Typography variant="body2"><strong>Titular:</strong> {verProveedor.banco_nombre_titular || "—"}</Typography>
                  <Typography variant="body2"><strong>CI/RUC Titular:</strong> {verProveedor.banco_cedula_titular || "—"}</Typography>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <Divider />
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => { setVerProveedor(null); abrirDialogo(verProveedor); }} startIcon={<Edit />}>Editar</Button>
            <Button onClick={() => setVerProveedor(null)} variant="contained">Cerrar</Button>
          </DialogActions>
        </>)}
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
